/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Filters.tsx
 */

export default class QueryFilter<T> {
    public fields: T;

    constructor(fields: T) {
        this.fields = fields;
    }

    /**
     * serialize
     */
    public serialize(): string {
        /**
         * remove undefined values
         */
        Object.keys(this.fields).forEach(key => {
            // @ts-ignore
            if (this.fields[key] === undefined) delete this.fields[key]
        })

        let urlSearchParams = new URLSearchParams(this.fields as any);
        return urlSearchParams.toString();
    }
}